<template>
  <div class="industry-report-wrapper">
    <div class="form-wraper"
         v-show="noResult">
      <h2>行业效果报告</h2>
      <el-form :model="formData"
               ref="formData"
               :rules="rules"
               label-width="120px">
        <el-form-item label="行业"
                      prop="industryId">
          <sky-select v-model="formData.industryId"
                      :options="industryList"
                      :props="{label:'name',value:'id'}"
                      placeholder="请选择外贸一级行业"></sky-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <date-switch-selector v-if="noResult"
                                timeType="week"
                                :groups="timeSwitch"
                                class="date-switch"
                                @reportData="getReportData"></date-switch-selector>
        </el-form-item>
        <el-form-item label="接收邮箱"
                      prop="email">
          <sky-input v-model="formData.email"
                     placeholder="请输入接收邮箱，多个请用逗号分开"
                     :scope="email_bind"></sky-input>
        </el-form-item>
      </el-form>

      <el-button type="primary"
                 @click="sendReport"
                 :loading="loading">发送报告</el-button>
    </div>
    <div v-show="!noResult"
         class="keyword-detail-inspectoscope">
      <h2>成功建立任务</h2>
      <h5 class="text">目前正在进行行业效果报告，成功后会将结果发送至目标邮箱，请注意查收。</h5>
      <el-button type="primary"
                 @click="reAnalysis">继续分析</el-button>
    </div>
  </div>
</template>

<script>
import formCombination from "@/components/iglobalwin/formCombination/formCombination.vue";
import serApi from '@/backend/services/account/service.js'
import dateSwitchSelector from '@/components/dateSwitchSelector/dateSwitchSelector';
import {
  timeSwitch
} from '@/common/dictionary.js';
import skyInput from '@/components/iglobalwin/formComponents/sky-input.vue'
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
export default {
  name: 'industry-report-wrapper',
  components: {
    formCombination,
    dateSwitchSelector,
    skyInput,
    skySelect
  },
  data () {
    return {
      loading: false,
      noResult: true,
      timeSwitch,
      datePicker: '',
      formData: {
        industryId: '',
        email: ''
      },
      email_bind: {
        vSlot: 'append',
        slotProp: '@skytech.cn',
      },
      industryList: [],
      rules: {
        industryId: [
          { required: true, message: '请选择外贸一级行业', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入接收邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    reAnalysis () {
      this.noResult = true
      this.loading = false
      this.reset()
    },
    reset () {
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
      })
    },
    // 分隔符
    getPhrase (phrase) {
      if (!phrase) throw new Error('phrase is not null')
      const _join = (pre) => `${pre}@skytech.cn`
      const [cnPhr, enPhr] = ['，', ',']
      if (phrase.indexOf(cnPhr) >= 0) {
        let transPhrase = phrase.replace(/，/g, enPhr)
        let phraseArr = transPhrase.split(enPhr)
        return phraseArr.map(item => _join(item)).join(';')
      } else if (phrase.indexOf(enPhr) >= 0) {
        let phraseArr = phrase.split(enPhr)
        return phraseArr.map(item => _join(item)).join(';')
      }
      return _join(phrase)
    },
    sendReport () {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            let params = {}
            const { formData, datePicker } = this
            let email = this.getPhrase(formData.email)
            params = {
              industryId: formData.industryId,
              email,
              ...datePicker
            }
            let res = await serApi.industryReport(params)
            if (res.status >= 200 && res.status < 400) {
              this.noResult = false
            }
          } catch (e) {
            this.loading = false
            console.error(e)
          }
        }
      })
    },
    async getIndustryList () {
      try {
        let res = await serApi.getIndustryList({ parentId: '0' })
        if (res.status >= 200 && res.status < 400) {
          this.industryList = res.data
        }
      } catch (e) {
        console.error(e)
      }
    },
    getReportData (obj) {
      let param = {}
      const dateDic = [
        {
          label: 'DAILY', value: '日报'
        },
        {
          label: 'WEEKLY', value: '周报'
        },
        {
          label: 'MONTHLY', value: '月报'
        }
      ]
      let type = dateDic.find(item => item.label == obj.selecttimetype).value
      param = {
        startDate: obj.startDate,
        endDate: obj.endDate,
        searchType: type
      }
      this.datePicker = param
    }
  },
  created () {
    this.getIndustryList()
  },
  mounted () {

  },
}
</script>

<style lang="scss" scoped>
.industry-report-wrapper {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 20px;
  text-align: center;
  .form-wraper {
    width: 750px;
    margin: auto;
    h2 {
      margin-bottom: 40px;
    }
  }
  .text {
    margin: 40px 0;
  }
}
.date-switch {
  box-shadow: none;
  & > .time-switch {
    height: 40px !important;
  }
}
</style>
<style >
.industry-report-wrapper .date-switch .time-switch {
  height: 40px !important;
}

.industry-report-wrapper .el-form {
  overflow: hidden;
}
.industry-report-wrapper .el-form-item__label {
  padding: 0 38px 0 0;
}
.industry-report-wrapper .el-form-item {
  margin-bottom: 20px;
}
</style>